export function getClass(element: Element) {
	return element.getAttribute('class') || '';
}
